<template>
    <div>
        <!-- 정보입력 -->
        <!-- 정보입력: 일반 -->
        <div class="mb-6">
            <p class="font-size-14 text-right"><span style="color: rgb(255, 0, 0);">*</span> 필수입력입니다.</p>
        </div>
        <div class="table-style table-style--default">
            <div class="table-style__row">
                <div class="table-style__th">아이디 <span style="color:#ff0000;">*</span></div>
                <div class="table-style__td">
                    <v-text-field v-model="user.username" @input="input" type="text" name="username" outlined hide-details class="w-100 mw-lg-500px" />
                </div>
            </div>
            <div class="table-style__row">
                <div class="table-style__th">비밀번호 <span style="color:#ff0000;">*</span></div>
                <div class="table-style__td">
                    <v-text-field v-model="user.password" @input="input" type="password" name="password" outlined hide-details class="w-100 mw-lg-500px" />
                    <small class="text-grey text-grey--right">(영문대소문자/숫자/특수문자 중 2가지 이상 조합, 8 - 16자)</small>
                </div>
            </div>
            <div class="table-style__row">
                <div class="table-style__th">비밀번호 확인 <span style="color:#ff0000;">*</span></div>
                <div class="table-style__td">
                    <v-text-field v-model="user.passwordConfirm" @input="input" type="password" name="password2" outlined hide-details class="w-100 mw-lg-500px" />
                </div>
            </div>
            <div class="table-style__row">
                <div class="table-style__th">이름 <span style="color:#ff0000;">*</span></div>
                <div class="table-style__td">
                    <v-text-field v-model="user.name" @input="input" type="text" name="name" outlined hide-details class="w-100 mw-lg-500px" />
                </div>
            </div>
            <div class="table-style__row">
                <div class="table-style__th">성별</div>
                <div class="table-style__td">
                    <v-radio-group v-model="user.sex" row hide-details @input="input">
                        <v-radio label="여성" value="여성" />
                        <v-radio label="남성" value="남성" />
                        <v-radio label="선택하지 않음" :value="null" />
                    </v-radio-group>
                </div>
            </div>
            <div class="table-style__row">
                <div class="table-style__th">생년월일 <span style="color:#ff0000;">*</span></div>
                <div class="table-style__td">
                    <v-text-field v-model="user.bornAt" @input="input" type="date" name="bornAt" outlined hide-details class="w-100 mw-lg-500px" />
                </div>
            </div>
            <div class="table-style__row">
                <div class="table-style__th">국가</div>
                <div class="table-style__td">
                    <v-text-field v-model="user.nation" @input="input" type="text" name="nation" outlined hide-details class="w-100 mw-lg-500px" />
                </div>
            </div>
            <div class="table-style__row">
                <div class="table-style__th">연락처 <span style="color:#ff0000;">*</span></div>
                <div class="table-style__td">
                    <div class="mw-lg-500px">
                        <v-row class="row--x-small" align="center">
                            <v-col>
                                <v-text-field v-model="user.phone1" @input="input" type="tel" name="phone1" maxlength="4" outlined hide-details class="w-100" readonly @click="certify" />
                            </v-col>
                            <v-col cols="auto">-</v-col>
                            <v-col>
                                <v-text-field v-model="user.phone2" @input="input" type="tel" name="phone2" maxlength="4" outlined hide-details class="w-100" readonly @click="certify" />
                            </v-col>
                            <v-col cols="auto">-</v-col>
                            <v-col>
                                <v-text-field v-model="user.phone3" @input="input" type="tel" name="phone3" maxlength="4" outlined hide-details class="w-100" readonly @click="certify" />
                            </v-col>
                            <v-col cols="12" sm="auto">
                                <v-btn @click="certify" tile color="primary" class="w-100 w-sm-120px v-btn--input">본인인증</v-btn>
                            </v-col>
                        </v-row>
                    </div>
                </div>
            </div>
            <div class="table-style__row">
                <div class="table-style__th">이메일 <span style="color:#ff0000;">*</span></div>
                <div class="table-style__td">
                    <div class="mw-lg-500px">
                        <v-row class="row--x-small" align="center">
                            <v-col>
                                <v-text-field v-model="user.email1" type="text" name="email1" outlined hide-details class="w-100" />
                            </v-col>
                            <v-col cols="auto">@</v-col>
                            <v-col>
                                <v-text-field v-model="user.email2" type="text" name="email2" outlined hide-details class="w-100" />
                            </v-col>
                            <v-col cols="12" sm="auto">
                                <select v-model="user.email3" @change="user.email2 = user.email3" class="select w-100">
                                    <option :value="null">직접입력</option>
                                    <option :value="`naver.com`">naver.com</option>
                                    <option :value="`daum.net`">daum.net</option>
                                    <option :value="`google.com`">google.com</option>
                                </select>
                            </v-col>
                        </v-row>
                    </div>
                </div>
            </div>
            <div class="table-style__row">
                <div class="table-style__th">주소 <span style="color:#ff0000;">*</span></div>
                <div class="table-style__td">
                    <div class="mw-lg-500px">
                        <v-row class="row--x-small" align="center">
                            <v-col cols="9">
                                <v-text-field v-model="user.postcode" @click="searchAddress" type="text" placeholder="우편번호" readonly outlined hide-details class="w-100" />
                            </v-col>
                            <v-col cols="3">
                                <v-btn @click="searchAddress" tile color="primary" class="w-100 v-btn--input">검색</v-btn>
                            </v-col>
                            <v-col cols="12">
                                <v-text-field v-model="user.address1" @click="searchAddress" type="text" placeholder="기본주소" readonly outlined hide-details class="w-100" />
                            </v-col>
                            <v-col cols="12">
                                <v-text-field v-model="user.address2" type="text" placeholder="상세주소" outlined hide-details class="w-100" />
                            </v-col>
                        </v-row>
                    </div>
                </div>
            </div>
            <div class="table-style__row">
                <div class="table-style__th">직업</div>
                <div class="table-style__td">
                    <v-text-field v-model="user.occupation" @input="input" type="text" name="occupation" outlined hide-details class="w-100 mw-lg-500px" />
                </div>
            </div>
            <div class="table-style__row">
                <div class="table-style__th">직장</div>
                <div class="table-style__td">
                    <v-text-field v-model="user.companyName" @input="input" type="text" name="companyName" outlined hide-details class="w-100 mw-lg-500px" />
                </div>
            </div>
            <div class="table-style__row">
                <div class="table-style__th">정보수신방법 <span style="color:#ff0000;">*</span></div>
                <div class="table-style__td">
                    <v-row v-if="user?.notify" align="center" class="row--small">
                        <v-col v-for="(item, index) in user?.notify" :key="index" cols="auto">
                            <div class="d-flex flex-wrap align-center">
                                <v-checkbox v-model="item.enabled" :label="item.text" @input="input" hide-details class="d-inline-flex" />
                                <template v-if="item.enabled">
                                    <v-text-field outlined v-model="item.contact" placeholder="연락처" @input="input" hide-details class="ml-8" />
                                </template>
                            </div>
                        </v-col>
                    </v-row>
                </div>
            </div>
        </div>

        <!-- 하단버튼 -->
        <div class="bottom-button">
            <div class="v-btn--group v-btn--group--large">
                <v-btn x-large outlined color="grey-cb" class="w-100 mw-220px" @click="cancel()"><span class="primary--text">취소하기</span></v-btn>
                <v-btn x-large color="primary" class="w-100 mw-220px" @click="submit()">회원가입</v-btn>
            </div>
        </div>

        <daum-postcode ref="daum-postcode" @change="setAddress" />
        <kcp-cert ref="kcp-cert" @input="verify"></kcp-cert>
    </div>
</template>

<script>
import DaumPostcode from "@/components/plugins/daum/daum-postcode.vue";
import KcpCert from "@/components/plugins/kcp/kcp-cert.vue";

export default {
    components: {
        DaumPostcode,
        KcpCert,
    },
    props: ["value"],
    data() {
        return {
            user: this.$props.value || {},
        };
    },
    watch: {
        "user.email"() {
            this.$emit("input", this.user);
        },
        "user.email1"() {
            this.$set(this.user, "email", this.user.email1 && this.user.email2 ? `${this.user.email1}@${this.user.email2}` : null);
        },
        "user.email2"() {
            this.$set(this.user, "email", this.user.email1 && this.user.email2 ? `${this.user.email1}@${this.user.email2}` : null);
        },

        "user.phone"() {
            this.$emit("input", this.user);
        },
        "user.phone1"() {
            this.$set(this.user, "phone", this.user.phone1 && this.user.phone2 && this.user.phone3 ? `${this.user.phone1}-${this.user.phone2}-${this.user.phone3}` : null);
        },
        "user.phone2"() {
            this.$set(this.user, "phone", this.user.phone1 && this.user.phone2 && this.user.phone3 ? `${this.user.phone1}-${this.user.phone2}-${this.user.phone3}` : null);
        },
        "user.phone3"() {
            this.$set(this.user, "phone", this.user.phone1 && this.user.phone2 && this.user.phone3 ? `${this.user.phone1}-${this.user.phone2}-${this.user.phone3}` : null);
        },
    },
    methods: {
        input() {
            this.$emit("input", this.user);
        },
        cancel() {
            this.$router.go(-1);
        },

        submit() {
            if (this.validate()) this.$emit("submit", this.user);
        },

        certify() {
            this.$refs["kcp-cert"].auth();
        },

        searchAddress() {
            this.$refs["daum-postcode"].open();
        },
        setAddress({ postcode, address }) {
            this.user.postcode = postcode;
            this.user.address1 = address;
        },

        verify(payload) {
            this.user._certification = payload._certification;
            var [phone1, phone2, phone3] = payload.phone?.phoneNumberFormat()?.split("-");
            this.user.phone1 = phone1;
            this.user.phone2 = phone2;
            this.user.phone3 = phone3;
        },

        validate() {
            try {
                if (!this.user.username) throw new Error("아이디를 입력해주세요.");
                if (!this.user.password) throw new Error("비밀번호를 입력해주세요.");

                if (!this.checkPassword(this.user.password)) return false;
                if (!this.user.passwordConfirm) throw new Error("비밀번호 확인을 입력해주세요.");
                if (this.user.password != this.user.passwordConfirm) throw new Error("비밀번호를 확인해주세요");

                if (!this.user.name) throw new Error("이름을 입력해주세요.");
                // if (!this.user.sex) throw new Error("성별을 입력해주세요.");
                if (!this.user.bornAt) throw new Error("생년월일을 입력해주세요.");
                // if (!this.user.nation) throw new Error("국가를 입력해주세요.");

                if (!this.user.phone1 || !this.user.phone2 || !this.user.phone3) {
                    if (!this.user._certification) {
                        this.certify();
                        return false;
                    }
                }

                if (!this.user.email1 || !this.user.email2) throw new Error("이메일을 입력해주세요.");

                // if (!this.user.occupation) throw new Error("직업을 입력해주세요.");

                if (!this.user.notify.some(({ enabled }) => enabled)) throw new Error("정보수신방법을 입력해주세요.");

                return true;
            } catch (error) {
                alert(error.message);
            }
            return false;
        },

        checkPassword(password) {
            var checkSpecial = /[~!@#$%^&*()_+|<>?:{}]/;
            var checkEng = /[a-zA-Z]/;
            var checkNum = /[0-9]/;

            if (!checkSpecial.test(password)) throw new Error("비밀번호에 특수문자가 포함되어있어야합니다.");
            if (!checkEng.test(password)) throw new Error("비밀번호에 영문이 포함되어있어야합니다.");
            if (!checkNum.test(password)) throw new Error("비밀번호에 숫자가 포함되어있어야합니다.");

            if (password.length < 8 || 16 < password.length) throw new Error("비밀번호는 8~16자까지입니다.");

            return true;
        },
    },
};
</script>
